import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import close from "@assets/icons/close-sesion.svg";
import Direccion from "@components/Direccion";
import axios from "@fetch/axios";
import { TokenContext } from "@context/TokenContext";
import { useTranslation } from "@hooks/useTranslation";
import 'rsuite/dist/rsuite.min.css';
import CardBenefits from "@components/CardBenefits";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import RedwardInformation from "@components/RedwardInformation";
import Swal from 'sweetalert2';
import { CartContext } from "@context/CardContext";

const Component = () => {

  const navigate = useNavigate();
  const [direcciones, setDirecciones] = useState([]);
  const [user, setUser] = useState(null);
  const { translate } = useTranslation();
  const { getToken,getVerified } = useContext(TokenContext);
  const { lang } = useContext(LanguageCurrencyContext);
  const {resetCart} = useContext(CartContext);

  const btnunsubscribe = () => {
      
      Swal.fire({
          title: translate('view.myprofile.unsubscribe_title'),
          html: translate('view.myprofile.unsubscribe_text'),
          icon: 'info',
          confirmButtonText: translate('view.myprofile.unsubscribe_confirm'),
      });
  };

  useEffect(() => {

    const fetchDirecciones = async () => {
      try {

        const storedToken = getToken();
        const verified = getVerified();
        
        const response = await axios.get('/addresses/list?verified=' + (verified ? 1 : 0),
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${storedToken}`
            },
          }
        );
        setDirecciones(response.data);
      } catch (error) {
        console.error('Error fetching address list', error);
      }
    };

    fetchDirecciones();
  }, []);

  useEffect(() => {


    const fetchUsuario = async () => {
      try {

        const storedToken = getToken();

        const response = await axios.get('/users/data?lang=' + lang,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${storedToken}`
            },
          }
        );
        setUser(response.data);
        localStorage.setItem('user_arteonu', JSON.stringify(response.data))
      } catch (error) {
        console.error('Error fetching user get', error);
      }
    };

    const getCountries = async ()=>{

      if (!localStorage.getItem('countries_arteonu')) {
        try {
          const response = await axios.get(`/countries?lang=${localStorage.getItem('lang_arteonu')}`);
          localStorage.setItem('countries_arteonu', JSON.stringify(response.data));
        } catch (error) {
          console.error('Error fetching countries:', error);
        }
      }
    }
    getCountries()
    fetchUsuario()
  }, [lang]);

  const cerrarSesion = () => {
    // Preserve selected keys across logout
    const preserveKeys = ['countries_arteonu', 'lang_arteonu', 'arteonu_old_year'];
    const preserved = preserveKeys.reduce((acc, key) => {
      const val = localStorage.getItem(key);
      if (val !== null) acc[key] = val;
      return acc;
    }, {});

    // Clear storage and restore preserved keys
    localStorage.clear();
    Object.entries(preserved).forEach(([k, v]) => localStorage.setItem(k, v));
    resetCart()
    navigate('/')
  }

  return (
    <>
      <div className="PerfilContent pt-tophead">

        <div className={`CategoryTitle PerfilSection`}>
          <ul className="Breadcrumb">
            <li style={{ "cursor": "pointer" }} onClick={() => navigate('/')}>Home</li>
            <li>{translate('view.myprofile.my_profile')}</li>
          </ul>
        </div>


        <RedwardInformation user={user} />


        <hr />
        <section className="PerfilData">

          {/* EDITAR MIS DATOS */}
          <article>
            <div className="grid">
              <div className="icon-IdentificationCard"></div>
              <b>{translate('view.myprofile.my_info')}</b>
            </div>
            <div className="ItemData">
              <div className="Selected">
                <div><strong>{translate('view.myprofile.name')}:</strong> {user ? user.name + ' '+ (user.lastname ?? '') : translate('view.loading')}</div>
              </div>
            </div>
            <div className="ItemData">
              <div className="Selected">
                <div><strong>{translate('view.myprofile.phone')}:</strong> {user ? '+' : translate('view.loading')} {user ? user.phone : ''}</div>
              </div>
            </div>
            <div className="ItemData">
              <div className="Selected">
                <div><strong>{translate('view.myprofile.email')}:</strong> {user ? user.email : translate('view.loading')}</div>
              </div>
            </div>
            <div className="ItemData">
              <div className="Selected">
                <div><strong>{translate('view.myprofile.membership_number')}:</strong> {user ? user.loyalty.affiliation : translate('view.loading')} </div>
              </div>
            </div>
            <div className="ItemData">
              <div className="Selected">
                <div><a href="javascript:void(0)" className="link" onClick={() => navigate("/mi-perfil/editar-datos")}>{translate('view.myprofile.edit_my_profile')}</a></div>
              </div>
            </div>
            <div className="ItemData" onClick={() => { cerrarSesion() }}>
              <div className="Selected">
                <div><a href="javascript:void(0)" className="link"> <img src={close} alt="" /> {translate('view.myprofile.log_out')}</a></div>
              </div>
            </div>
            <div className="ItemData">
              <div className="Selected">
                <div><button className="ButtonDark btnunsubscribe" onClick={btnunsubscribe}>{translate( 'view.myprofile.unsubscribe')}</button></div>
              </div>
            </div>
          </article>

          {/* MIS PEDIDOS */}
          <article>
            <div className="box">
              <div className="grid">
                <div className="icon-Package"></div>
                <b>{translate('view.orders.title')} <em>{translate('view.orders.subtitle')}</em></b>
              </div>
            </div>

              <div className="ButtonLight ButtonContent SeePackages" onClick={() => navigate("/mis-pedidos")}>
                {translate('view.orders.view')}
              </div>
            
          </article>

          {/* DIRECCIONES */}
          <article>
            <div className="box">
              <div className="grid">
                <div className="icon-HouseLine"></div>
                <b>{translate('view.address.title')} <em>{translate('view.address.subtitle')} </em></b>
              </div>

              {direcciones &&
                direcciones.map((direccion, index) => (
                  <Direccion
                    key={direccion.id || index} stored address={direccion}
                    edit={translate('view.address.edit')} />
                ))
              }

            </div>

              {direcciones.length < 3 &&
                <div className="ButtonLight ButtonContent SeePackages" onClick={() => { navigate('/mi-perfil/agregar-direccion') }}>
                  <i>+</i>
                  {translate('checkout.add_address')}
                </div>}
            
          </article>

        </section>

        {/* Beneficios */}
        <CardBenefits />

      </div>
    </>
  );
};

export default Component;
